let eventId = 0;
const getEventId = () => eventId++;

export const generateGovolteEventId = (pageViewId: string) =>
  `${pageViewId}#${getEventId()}`;
